export const SIGNED_IN_PAYLOAD_EVENT = "signedIn";
export const SIGNED_OUT_PAYLOAD_EVENT = "signedOut";

export const RESEND_CODE_COOLDOWN_SECONDS = 60;

export enum AuthContext {
  SIGN_IN = "signIn",
  SIGN_UP = "signUp",
  CONFIRM_SIGN_UP = "confirmSignUp",
  CONFIRM_SIGN_IN = "confirmSignIn",
  FORGOT_PASSWORD = "forgotPassword",
  RESET_PASSWORD = "resetPassword",
  RESEND_CONFIRM_SIGN_UP_CODE = "resendSignUpCode",
  RESEND_RESET_PASSWORD_CODE = "resendResetPasswordCode",
  EMAIL_CHANGE = "emailChange",
  RESEND_EMAIL_CHANGE_CODE = "resendEmailChangeCode",
  CONFIRM_EMAIL_CHANGE = "confirmEmailChange",
  CHANGE_PASSWORD = "changePassword"
}
